import { render } from "./HeroGlobal.vue?vue&type=template&id=4703b1ce&scoped=true"
import script from "./HeroGlobal.vue?vue&type=script&lang=js"
export * from "./HeroGlobal.vue?vue&type=script&lang=js"

import "./HeroGlobal.vue?vue&type=style&index=0&id=4703b1ce&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4703b1ce"]])

export default __exports__